import React, { useEffect, useRef, useState } from "react";

//MUI IMPORTS
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Switch from "@mui/material/Switch";
import {
  Box,
  TextField,
  Autocomplete,
  Button,
  DialogActions,
  Grid,
  Typography,
  Paper,
  Fade,
  IconButton,
  Alert,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
// import CancelIcon from '@mui/icons-material/Cancel';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import * as api from "../api";

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
  color: "#ffffff",
  padding: "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  "& .MuiTypography-root": {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "1.25rem",
    fontWeight: 450,
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "10px 14px",
  backgroundColor: "#f1f5f9",
  borderRadius: "12px",
  marginBottom: "24px",
  border: "1px solid #e2e8f0",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(22, 78, 99, 0.08)",
  },
}));

const label = { inputProps: { "aria-label": "Color switch demo" } };

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#164e63",
    "&:hover": {
      backgroundColor: alpha("#164e63", 0.08),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#164e63",
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#475569",
  },
}));

function DialogSelecComprobante({
  open,
  setOpen,
  dataCliente,
  paramsNegocios,
  setComprobanteAsociado,
  setItems,
  setAnulacionCompleta,
  setFormData,
}) {
  const negocio = JSON.parse(
    paramsNegocios.find(
      (negocio) => negocio.idtipocliente == dataCliente.id_negocio_cliente
    ).params
  );
  const [cargando, setCargando] = useState(false);
  const [comprobantes, setComprobantes] = useState();
  const [comprobanteSeleccionado, setComprobanteSeleccionado] = useState();
  const [itemsFactura, setItemsFactura] = useState();
  // const [noAnula, setNoAnula] = useState();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    api.getComprobantesCliente(
      dataCliente.id,
      setComprobantes,
      negocio.envasado
    );
  }, []);

  const handleSubmit = (anulacionCompleta
    // , noAnula
  ) => {
    //vuelvo a cheq por si las moscas.
    // if (noAnula) {
    //   setComprobanteAsociado(comprobanteSeleccionado);
    //   setItems([
    //     {
    //       cantidad: "",
    //       unidadMedida: "",
    //       descUnidadMedida: "",
    //       precioUnitario: "",
    //       totalItem: "",
    //       idProducto: null,
    //     },
    //   ]);
    //   setOpen(false)
    //   return;
    // }

    if (!!anulacionCompleta) {
      setAnulacionCompleta(true);
      setComprobanteAsociado(comprobanteSeleccionado);
      let itemsGuardar = itemsFactura.map((item) => ({
        cantidad: item.cantidad,
        idProducto: item.id_producto,
        precioUnitario: item.precio_unitario,
        unidadMedida: item.id_unidad_medida,
        descUnidadMedida: item.unidad_medida,
        totalItem: item.total_item,
        descripcion: item.detalle,
      }));
      setItems(itemsGuardar);
      setFormData((prev) => {
        return {
          ...prev,
          sucEmisora: comprobanteSeleccionado.id_sucursal_factura,
          empEmisora: comprobanteSeleccionado.id_empresa,
        };
      });
    } else {
      setComprobanteAsociado(comprobanteSeleccionado);
      setAnulacionCompleta(false);
      setItems([
        {
          cantidad: "",
          unidadMedida: "",
          descUnidadMedida: "",
          precioUnitario: "",
          totalItem: "",
          idProducto: null,
        },
      ]);
      setFormData((prev) => {
        return {
          ...prev,
          sucEmisora: comprobanteSeleccionado.id_sucursal_factura,
          empEmisora: comprobanteSeleccionado.id_empresa,
          aConsFinal: comprobanteSeleccionado.cuit_dni.length === 11 ? 0 : 1,
        };
      });
    }
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            boxShadow: "0 20px 60px rgba(22, 78, 99, 0.15)",
          },
        }}
      >
        <StyledDialogTitle>
          <Typography component="div">
            <SearchIcon sx={{ fontSize: "28px" }} />
            Emisión de Notas De Crédito
          </Typography>
          <IconButton
            onClick={() => {
              handleClose();
            }}
            sx={{
              color: "#ffffff",
              "&:hover": {
                backgroundColor: alpha("#ffffff", 0.1),
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContent
          sx={{ padding: "32px", backgroundColor: "#ffffff", mt: 3, mb: 1 }}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <>
              <Box sx={{ pt: 2 }}>
                <Autocomplete
                  disableClearable
                  placeholder="N° de factura"
                  options={comprobantes || [{}]}
                  loading={cargando}
                  loadingText="Cargando..."
                  value={comprobanteSeleccionado}
                  onChange={(e, value) => {
                    setComprobanteSeleccionado(value);
                    api.getItemsComprobante(value.uuid, setItemsFactura);
                  }}
                  noOptionsText={"Tipee para buscar comprobante.."}
                  getOptionLabel={(option) => {
                    return ` ${option?.texto_comprobante} ${option?.letra} ${option?.pto_venta}-${option?.nro_comprobante}`;
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option?.id_factura === value?.id_factura
                  }
                  renderOption={(props, option) => {
                    return (
                      <Box
                        component="li"
                        {...props}
                        key={option.id}
                        sx={{
                          padding: "12px 16px !important",
                          borderBottom: "1px solid #f1f5f9",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "#f1f5f9 !important",
                          },
                          '&[aria-selected="true"]': {
                            backgroundColor:
                              alpha("#164e63", 0.08) + " !important",
                            color: "#164e63",
                            fontWeight: 600,
                          },
                        }}
                      >
                        {option?.texto_comprobante} {option?.letra}{" "}
                        {option?.pto_venta}-{option?.nro_comprobante}
                      </Box>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      helperText="SÓLO facturas del mes corriente."
                      {...params}
                      label="Comprobantes"
                      variant="outlined"
                      placeholder="Buscar comprobante a anular..."
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "#ffffff",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#164e63",
                            },
                          },
                          "&.Mui-focused": {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#164e63",
                              borderWidth: "2px",
                            },
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "#475569",
                          fontWeight: 500,
                          "&.Mui-focused": {
                            color: "#164e63",
                          },
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                      }}
                    />
                  )}
                />

                {comprobanteSeleccionado?.importe_percepciones > 0 || comprobanteSeleccionado?.importe_perc_iva > 0 && (
                  <Grid item lg={12} md={12} xs={12}>
                    <Alert severity="warning">
                      Este comprobante contiene percepciones. Sólo podrá
                      anularse su totalidad.
                    </Alert>
                  </Grid>
                )}
              </Box>
            </>
            {/* )} */}
          </form>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "0px 32px 32px",
            backgroundColor: "#ffffff",
            justifyContent: "space-between",
          }}
        >
          <>
            <Button
              disabled={
                comprobanteSeleccionado?.importe_percepciones > 0 ||
                !comprobanteSeleccionado || comprobanteSeleccionado?.importe_perc_iva > 0
              }
              variant="contained"
              color="primary"
              onClick={() => handleSubmit(false)}
              sx={{
                borderRadius: "10px",
                padding: "10px 32px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                backgroundColor: "#164e63",
                boxShadow: "0 4px 12px rgba(22, 78, 99, 0.25)",
                "&:hover": {
                  backgroundColor: "#0c3a47",
                  boxShadow: "0 6px 16px rgba(22, 78, 99, 0.35)",
                },
                "&:disabled": {
                  backgroundColor: "#cbd5e1",
                  color: "#94a3b8",
                },
              }}
            >
              Anulación Parcial
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!comprobanteSeleccionado}
              onClick={(e) => {
                setAnulacionCompleta(true);
                handleSubmit(true);
              }}
              endIcon={<ArrowForwardIcon />}
              sx={{
                borderRadius: "10px",
                padding: "10px 32px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                backgroundColor: "#16a34a",
                boxShadow: "0 4px 12px rgba(22, 163, 74, 0.25)",
                "&:hover": {
                  backgroundColor: "#15803d",
                  boxShadow: "0 6px 16px rgba(22, 163, 74, 0.35)",
                },
                "&:disabled": {
                  backgroundColor: "#bbf7d0",
                  color: "#4b5563",
                },
              }}
            >
              Anulación Total
            </Button>
            {/* <Button
              variant="contained"
              color="primary"
              onClick={() => handleSubmit(false, true)}
              // disabled={!comprobanteSeleccionado}
              // onClick={(e) => {
              //   handleSubmit(false, );
              // }}
              // endIcon={<ArrowForwardIcon />}
              sx={{
                borderRadius: "10px",
                padding: "10px 32px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                backgroundColor: "#16a34a",
                boxShadow: "0 4px 12px rgba(22, 163, 74, 0.25)",
                "&:hover": {
                  backgroundColor: "#15803d",
                  boxShadow: "0 6px 16px rgba(22, 163, 74, 0.35)",
                },
                "&:disabled": {
                  backgroundColor: "#bbf7d0",
                  color: "#4b5563",
                },
              }}
            >
              no se asocia a nada
            </Button> */}
          </>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DialogSelecComprobante;

{
  /* <Grid container alignItems="center" justifyContent="space-between" >
                                <Grid item xs={8} >
                                    <Typography
                                        sx={{
                                            color: "#164e63",
                                            fontWeight: 600,
                                            fontSize: "0.95rem",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <CancelIcon color="error" sx={{ fontSize: "20px" }} />
                                        Anular Factura
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <CustomSwitch
                                        checked={anulacionCompleta}
                                        onChange={(e) => {
                                            setAnulacionCompleta(e.target.checked);
                                            setComprobanteAAnular(null);
                                        }}
                                        {...label}
                                    />
                                </Grid>
                            </Grid> */
}
